import { gql } from '@apollo/client';

const GET_CLIENTS = gql`
  query GetClients($params: QueryParams, $search: String,  $location: QueryOperators) {
    clients(params: $params, search: $search, , location: $location) {
      results {
        id
        user {
          firstName
          lastName
          email
          }
          moneySpent
          selectedLocation {
          id
          name
          address {
            fullName
          }
        }
        fiscalData {
          name
          rfc
          email
          regimenFiscal
          usoCFDI
          address {
            country
            city
            state
            street
            postcode
            colony
            internalNumber
            exteriorNumber
          }
        }
      }
    }
  }
`;

const GET_LOCATIONS = gql`
  query getLocations($params: QueryParams) {
    locations(params: $params) {
      results {
        id
        name
        phone
        subZone {
          id
          name
        }
        address {
          fullName
          street
          colony
          exteriorNumber
          postcode
          city
          state
          country
          location {
            type
            coordinates
          }
        }
      }
    }
  }
`;

export { GET_CLIENTS, GET_LOCATIONS };
